import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownMessage = ({ content }) => {
  return (
    <div className="prose prose-slate">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownMessage;
